"use client";

import { useT } from "@/Hooks";
import { Result } from "antd";
import { FC } from "react";

const LandingBandwidthBlockedPage: FC = () => {
  const t = useT();

  return (
    <Result
      status="warning"
      title={t("landing.bandwidthBlocked.title")}
      subTitle={t("landing.bandwidthBlocked.description")}
    />
  );
};

export default LandingBandwidthBlockedPage;
